import { compose, defaultProps, withPropsOnChange } from 'recompose'
import get from 'lodash/get'
import EquipmentFormatter from 'components/EquipmentFormatter'

const EquipmentClassFormatter = compose(
  defaultProps({
    extractText: (equipment) => get(equipment, `voltage.link.value`),
  }),
  withPropsOnChange([`allData`], ({ allData = {} }) => {
    const { objectId } = allData
    return {
      value    : objectId,
      textField: ``,
    }
  }),
)(EquipmentFormatter)

export default EquipmentClassFormatter
